export default "__VITE_ASSET__DoDiZ9x1__"